import * as React from "react";
import Header from '../About/Navbar';
import FeatureSection from './FeatureSection';
import SearchSection from './SearchSection';
import UsersSection from './UsersSection';
import Footer from '../About/Footer';
import './MyComponent.css';

function Screening() {
  return (
    <div className="after-get-started-on-screening-testt">
      <Header />
      <FeatureSection />
      <div className="content-container">
        <div className="search-and-users">
          <SearchSection />
          <UsersSection />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Screening;